/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FormFlowState } from './form-actions.service';

export function whenFormInvalid(state: FormFlowState<any>): boolean {
  return state.form.invalid;
}

export function highlightAll(state: FormFlowState<any>): void {
  if (state.form.highlightAll) {
    state.form.highlightAll();
  }
}
